module.exports = __webpack_public_path__ + "img/Rectanglenew.e1a58210.png";